import styles from './styles.module.scss';

export function ContentsHeader({
  title,
  description = '',
  actions = null,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className={styles.Header}>
      <div className={styles.Header__TitleContainer}>
        <h1 className={styles.Header__Title}>{title}</h1>
        {description && <div className={styles.Header__Description}>{description}</div>}
      </div>
      <div className={styles.Header__Actions}>{actions}</div>
    </div>
  );
}
